var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portal"},[(_vm.filterSepcialRoute)?void 0:[_c('slider-nav'),_c('div',{staticClass:"portal-content"},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }